import PropTypes from "prop-types"
import React from "react"
import Grid from "semantic-ui-react/dist/es/collections/Grid/Grid"

const WorksheetBody = ({ children, blue }) => {
  let gridClassName =
    "WorksheetGroup__Grid " + (blue ? "lighter-blue" : "white")
  const flattenedChildren = flattenChildren(
    React.Children.toArray(children)
  ).map((child, index) => {
    return React.cloneElement(child, { key: index, error: getRowError(child) })
  })

  function getRowError(row) {
    let fields = []
    React.Children.toArray(row.props.children).forEach(child => {
      if (child.type.displayName === "WorksheetField") {
        fields.push(child)
      } else if (child.type.displayName === "WorksheetFieldGroup") {
        React.Children.toArray(child.props.children)
          .filter(
            groupChild => groupChild.type.displayName === "WorksheetField"
          ) // Just to make sure
          .forEach(field => fields.push(field))
      }
    })
    const fieldsWithError = fields.filter(field => field.props.error)
    return fieldsWithError.length > 0
      ? fieldsWithError.map(field => field.props.error)
      : false
  }

  function flattenChildren(rowchilds, level = 0) {
    var newChildren = []
    rowchilds
      .filter(row => row !== null)
      .forEach((item, index) => {
        const showNumbers = React.Children.toArray(children).length > 1
        if (Array.isArray(item.props.children)) {
          let field
          let rowCollection = []
          let subRows = []
          item.props.children
            .filter(child => child !== null)
            .forEach(child => {
              if (child.type.displayName === "WorksheetRow") {
                subRows.push(child)
              } else if (child.type.displayName === "WorksheetField") {
                field = child
              } else if (child.type.displayName === "WorksheetRowCollection") {
                rowCollection.push(child) // Ideal State: Children of WorksheetRowCollection must be WorksheetRow(s)
              }
            })
          newChildren.push(
            React.cloneElement(item, {
              level,
              number: level < 2 ? getLevelBasedNumber(level, index) : false,
              children: field,
              noTopBorder: level > 0,
              showNumbers
            })
          )
          newChildren = newChildren
            .concat(flattenChildren(rowCollection, level))
            .concat(flattenChildren(subRows, level + 1))
        } else {
          newChildren.push(
            React.cloneElement(item, {
              level,
              number: level < 2 ? getLevelBasedNumber(level, index) : false,
              noTopBorder: level > 0,
              showNumbers
            })
          )
        }
      })
    return newChildren
  }

  return (
    <Grid.Row>
      <Grid.Column>
        <Grid className={gridClassName} stackable>
          {flattenedChildren}
        </Grid>
      </Grid.Column>
    </Grid.Row>
  )
}

WorksheetBody.propTypes = {
  blue: PropTypes.bool
}

/* HELPERS */

function getLevelBasedNumber(level, index) {
  return [
    () => index + 1,
    () =>
      "a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y,z".split(",")[index],
    () => toRoman(index + 1),
    () => toRoman(index + 1).toLowerCase()
  ][level % 4]()
}

// REF: http://www.selftaughtjs.com/algorithm-sundays-converting-roman-numerals/
function toRoman(num) {
  var result = ""
  var decimal = [1000, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1]
  var roman = [
    "M",
    "CM",
    "D",
    "CD",
    "C",
    "XC",
    "L",
    "XL",
    "X",
    "IX",
    "V",
    "IV",
    "I"
  ]
  for (var i = 0; i <= decimal.length; i++) {
    while (num % decimal[i] < num) {
      result += roman[i]
      num -= decimal[i]
    }
  }
  return result
}

export default WorksheetBody
